module.exports = {
    password: 'Пароли должны соответствовать друг другу и содержать не менее 6 символов.',
    reset: 'Ваш пароль успешно сброшен!',
    sent: 'Мы отправили ссылку для восстановления пароля на ваш адрес!',
    token: 'Недействительный токен для сброса пароля.',
    user: 'Нам не удалось найти пользователя с указанным адресом.',
}